import { render, staticRenderFns } from "./LoginCardUnauthorized.vue?vue&type=template&id=70652c3f&scoped=true"
import script from "./LoginCardUnauthorized.vue?vue&type=script&lang=ts"
export * from "./LoginCardUnauthorized.vue?vue&type=script&lang=ts"
import style0 from "./LoginCardUnauthorized.vue?vue&type=style&index=0&id=70652c3f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70652c3f",
  null
  
)

export default component.exports